<tql-header></tql-header>

<router-outlet *ngIf="!isIframe && isAuthenticated"></router-outlet>

<div class="spinner-overlay" *ngIf="asyncCallInProgress || navigationInProgress">
    <div class="loader"></div>
</div>

<tql-footer></tql-footer>